export default "__VITE_ASSET__BxwJRomL__"